import { useTranslation } from 'react-i18next';
import yardireacttranslationService, { initTranslations } from './yardireacttranslationService';
export { yardiTranslationConfig } from './yardireacttranslationService';
// Re-export React i18next primitives so consumers only import from this service
export { Trans, useTranslation } from 'react-i18next';
// Expose the initialized i18n instance for non-React usage
export const i18n = yardireacttranslationService.i18n;
// Provide a convenient translate function usable outside React components
// Note: Inside React components, prefer the hook: const { t } = useTranslation()
export const translate = i18n.t.bind(i18n);
// Optional helper hook mapping the requested names exactly
export const useTranslate = () => {
    const { t, i18n: i18nextInstance } = useTranslation();
    return { translate: t, i18n: i18nextInstance };
};
// Re-export the initTranslations function
export { initTranslations };
//var translate1 = useTranslate().translate;
//export const translate: typeof translate1 = translate1;
// Re-export the underlying localization service in case advanced consumers need it
export default yardireacttranslationService;
